import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import Hero from './components/sections/Hero';
import About from './components/sections/About';
import AboutDetails from './components/sections/AboutDetails';
import Services from './components/sections/Services';
import Contact from './components/sections/Contact';
import Footer from './components/layout/Footer';
import {
  Development,
  EProcurement,
  SecuritySolutions,
  ICTSystems,
  Consultancy,
  Immigration,
} from "./pages/services";

import { Helmet } from 'react-helmet-async';

function App() {
  return (
    <BrowserRouter>
      <div>
        <Header />
        {/* Add global top padding so content isn’t hidden under header */}
        <div className="pt-24">
          <Routes>
            {/* Home Page */}
            <Route
              path="/"
              element={
                <>
                  <Helmet>
                    <title>Northstart Systems | ICT & Security Solutions</title>
                    <meta
                      name="description"
                      content="Empowering digital transformation through reliable ICT, e-Procurement, and Security Solutions in Kenya."
                    />
                    <meta property="og:title" content="Northstart Systems" />
                    <meta
                      property="og:description"
                      content="Your trusted partner for ICT solutions."
                    />
                    <meta property="og:type" content="website" />
                    <link rel="canonical" href="https://northstartsystems.com/" />
                  </Helmet>

                  <main>
                    <Hero />
                    <About />
                    <Services />
                    <Contact />
                  </main>
                </>
              }
            />

            {/* About Page */}
            <Route
              path="/about"
              element={
                <>
                  <Helmet>
                    <title>About Us | Northstart Systems</title>
                    <meta
                      name="description"
                      content="Learn more about Northstart Systems, our mission, vision, and commitment to digital transformation."
                    />
                    <link rel="canonical" href="https://northstartsystems.com/about" />
                  </Helmet>

                  <main>
                    <About />
                  </main>
                </>
              }
            />

            {/* Services Page */}
            <Route
              path="/services"
              element={
                <>
                  <Helmet>
                    <title>Our Services | Northstart Systems</title>
                    <meta
                      name="description"
                      content="Explore Northstart Systems' services including web development, e-Procurement, and ICT security solutions."
                    />
                    <link rel="canonical" href="https://northstartsystems.com/services" />
                  </Helmet>

                  <main>
                    <Services />
                  </main>
                </>
              }
            />

            {/* Contact Page */}
            <Route
              path="/contact"
              element={
                <>
                  <Helmet>
                    <title>Contact Us | Northstart Systems</title>
                    <meta
                      name="description"
                      content="Get in touch with Northstart Systems for inquiries, partnerships, or ICT solutions support."
                    />
                    <link rel="canonical" href="hhttps://northstartsystems.com/contact" />
                  </Helmet>

                  <main>
                    <Contact />
                  </main>
                </>
              }
            />

            {/* Individual Service Detail */}
            <Route path="/service/development" element={<Development />} />
            <Route path="/service/e-procurement" element={<EProcurement />} />
            <Route path="/service/security-solutions" element={<SecuritySolutions />} />
            <Route path="/service/ict-systems-support" element={<ICTSystems />} />
            <Route path="/service/consultancy" element={<Consultancy />} />
            <Route path="/about/details" element={<AboutDetails />} /> 
            <Route path="/service/immigration-services" element={<Immigration />} />

          </Routes>
        </div>  


        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
